export const WC_MANAGEMENT_STATUS = {
  CONFIRMED: 'confirmed',
  DECLINED: 'declined',
};
